import { type CSSProperties } from 'react';

import {
  PANEL_COLLAPSED_HANDLE_WIDTH,
  WORKSPACE_CANVAS_HORIZONTAL_PADDING,
  WORKSPACE_MIN_WIDTH,
} from '~/constants/panelWidths';

export type GetWorkspaceContentStyleParams = {
  rightPanelOpen: boolean;
  isFullscreen: boolean;
  /** When the middle board view is collapsed, it shrinks to the pull-open handle strip. */
  boardViewCollapsed?: boolean;
  /** Board routes reserve a narrow strip for the pull-open handle; other pages collapse fully. */
  reserveCollapsedHandleStrip?: boolean;
};

export function getWorkspaceContentStyle({
  rightPanelOpen,
  isFullscreen,
  boardViewCollapsed = false,
  reserveCollapsedHandleStrip = false,
}: GetWorkspaceContentStyleParams): CSSProperties | undefined {
  if (!rightPanelOpen) {
    return undefined;
  }

  if (isFullscreen) {
    return { width: 0, minWidth: 0, overflow: 'hidden' };
  }

  if (boardViewCollapsed) {
    if (!reserveCollapsedHandleStrip) {
      return { width: 0, minWidth: 0, maxWidth: 0, flexShrink: 0, overflow: 'hidden' };
    }

    return {
      width: PANEL_COLLAPSED_HANDLE_WIDTH,
      minWidth: PANEL_COLLAPSED_HANDLE_WIDTH,
      maxWidth: PANEL_COLLAPSED_HANDLE_WIDTH,
      flexShrink: 0,
      overflow: 'hidden',
    };
  }

  return {
    width: `max(${WORKSPACE_MIN_WIDTH + WORKSPACE_CANVAS_HORIZONTAL_PADDING}px, calc(100vw - var(--left-nav-width, 0px) - var(--right-sidebar-width)))`,
  };
}
